import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const FlowQueryGql: DocumentNode = gql`
query FlowQuery($flowVizportalUrlId: String!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }, permissionMode: FILTER_RESULTS) {
    name
    outputSteps(orderBy: { field: NAME, direction: ASC }) {
      name
      id
      outputFieldsConnection {
        totalCount
      }
    }
  }
}
`;
